export const RxTableCell = {
  styleOverrides: {
    root: {
      border: '1px solid #ECF2EF',
    },
  },
};
